export const VALID_CREDENTIALS_TYPES = new Map([
  ["HA_Hospice Aide", { credential: "HA", description: "Hospice Aide" }],
  ["HA-C_Hospice Aide", { credential: "HA-C", description: "Hospice Aide" }],
  ["STNA_Hospice Aide", { credential: "STNA", description: "Hospice Aide" }],
  ["CNA_Hospice Aide", { credential: "CNA", description: "Hospice Aide" }],
  ["LPN_LPN/LVN Nurse", { credential: "LPN", description: "LPN/LVN Nurse" }],
  ["LVN_LPN/LVN Nurse", { credential: "LVN", description: "LPN/LVN Nurse" }],
  [
    "LPN_Licensed Nurse (LPN/LVN)",
    { credential: "LPN", description: "Licensed Nurse (LPN/LVN)" },
  ],
  [
    "LVN_Licensed Nurse (LPN/LVN)",
    { credential: "LVN", description: "Licensed Nurse (LPN/LVN)" },
  ],
  [
    "MD_Medical Director",
    { credential: "MD", description: "Medical Director" },
  ],
  [
    "DO_Medical Director",
    { credential: "DO", description: "Medical Director" },
  ],
  [
    "FNP-BC_Nurse Practitioner",
    { credential: "FNP-BC", description: "Nurse Practitioner" },
  ],
  [
    "ANP-BC_Nurse Practitioner",
    { credential: "ANP-BC", description: "Nurse Practitioner" },
  ],
  [
    "CRNP_Nurse Practitioner",
    { credential: "CRNP", description: "Nurse Practitioner" },
  ],
  [
    "APRN_Nurse Practitioner",
    { credential: "APRN", description: "Nurse Practitioner" },
  ],
  [
    "ACHPN_Nurse Practitioner",
    { credential: "ACHPN", description: "Nurse Practitioner" },
  ],
  [
    "PA-C_Physician Assistant",
    { credential: "PA-C", description: "Physician Assistant" },
  ],
  [
    "RN_Registered Nurse (RN)",
    { credential: "RN", description: "Registered Nurse (RN)" },
  ],
  [
    "RN-CHPN_Registered Nurse (RN)",
    { credential: "RN-CHPN", description: "Registered Nurse (RN)" },
  ],
  [
    "RN, BSN_Registered Nurse (RN)",
    { credential: "RN, BSN", description: "Registered Nurse (RN)" },
  ],
  [
    "RN, MSN_Registered Nurse (RN)",
    { credential: "RN, MSN", description: "Registered Nurse (RN)" },
  ],
  [
    "RN_Registered Nurse",
    { credential: "RN", description: "Registered Nurse" },
  ],
  [
    "RN-CHPN_Registered Nurse",
    { credential: "RN-CHPN", description: "Registered Nurse" },
  ],
  [
    "RN, BSN_Registered Nurse",
    { credential: "RN, BSN", description: "Registered Nurse" },
  ],
  [
    "RN, MSN_Registered Nurse",
    { credential: "RN, MSN", description: "Registered Nurse" },
  ],
  ["LBSW_Social Worker", { credential: "LBSW", description: "Social Worker" }],
  ["LMSW_Social Worker", { credential: "LMSW", description: "Social Worker" }],
  ["LCSW_Social Worker", { credential: "LCSW", description: "Social Worker" }],
  ["DSW_Social Worker", { credential: "DSW", description: "Social Worker" }],
  ["LMHC_Social Worker", { credential: "LMHC", description: "Social Worker" }],
  ["LMFT_Social Worker", { credential: "LMFT", description: "Social Worker" }],
  ["BSW_Social Worker", { credential: "BSW", description: "Social Worker" }],
  ["LISW_Social Worker", { credential: "LISW", description: "Social Worker" }],
  ["LSW_Social Worker", { credential: "LSW", description: "Social Worker" }],
  [
    "LMSW-AP_Social Worker",
    { credential: "LMSW-AP", description: "Social Worker" },
  ],
  [
    "LSCSW_Social Worker",
    { credential: "LSCSW", description: "Social Worker" },
  ],
  ["MSW_Social Worker", { credential: "MSW", description: "Social Worker" }],
  [
    "VC_Volunteer Coordinator",
    { credential: "VC", description: "Volunteer Coordinator" },
  ],
  ["BC_", { credential: "BC", description: "" }],
  ["Other", { credential: "Other", description: "" }],
]);

export const NO_CHECK_CREDENTIALS_TYPES = new Map([
  ["HC", { credential: "HC", description: "Home Maker" }],
]);

export const NO_CHECK_HOSPICE_TEAM_ROLE = new Map([
  [
    "Bereavement Counselor",
    {
      credential: "Bereavement Counselor",
      description: "Bereavement Counselor",
    },
  ],
  [
    "BC_Bereavement Counselor",
    {
      credential: "BC",
      description: "Bereavement Counselor",
    },
  ],
  ["Bereavement", { credential: "Bereavement", description: "Bereavement" }],
  ["Case Manager", { credential: "Case Manager", description: "Case Manager" }],
  ["Team Lead", { credential: "Team Lead", description: "Team Lead" }],
  [
    "Spiritual Advisor",
    { credential: "Spiritual Advisor", description: "Spiritual Advisor" },
  ],
  [
    "Spiritual Care",
    { credential: "Spiritual Care", description: "Spiritual Care" },
  ],
  [
    "Volunteer Coordinator",
    {
      credential: "Volunteer Coordinator",
      description: "Volunteer Coordinator",
    },
  ],
  ["Volunteer", { credential: "Volunteer", description: "Volunteer" }],
  [
    "Speech-Language Therapist",
    {
      credential: "Speech-Language Therapist",
      description: "Speech-Language Therapist",
    },
  ],
  [
    "Physical Therapist",
    { credential: "Physical Therapist", description: "Physical Therapist" },
  ],
  [
    "Occupational Therapist",
    {
      credential: "Occupational Therapist",
      description: "Occupational Therapist",
    },
  ],
  ["Nutritionist", { credential: "Nutritionist", description: "Nutritionist" }],
  ["Home Maker", { credential: "Home Maker", description: "Home Maker" }],
]);



// WEBPACK FOOTER //
// ./src/configs/credentialsTypes.ts